import React, { useState } from 'react';
import { industries } from '../data/mock';
import { Card, CardContent } from './ui/card';
import * as Icons from 'lucide-react';
import DomainDetailModal from './DomainDetailModal';

const Industries = () => {
  const bgColor = '#1a2332';
  const accentColor = '#d4af37';
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleDomainClick = (industry) => {
    setSelectedDomain(industry);
    setModalOpen(true);
  };

  return (
    <>
      <section id="industries" className="py-20 text-white" style={{ backgroundColor: bgColor }}>
        <div className="container mx-auto px-6">
          <div className="mb-16 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold md:text-5xl">Domain Expertise</h2>
            <div className="mx-auto h-1 w-24 rounded" style={{ backgroundColor: accentColor }}></div>
            <p className="mx-auto mt-6 max-w-3xl text-lg text-white opacity-90">
              Proven leadership across diverse industries with deep understanding of sector-specific talent requirements. Click on any domain to explore detailed insights.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
            {industries.map((industry, index) => {
              const IconComponent = Icons[industry.icon] || Icons.Briefcase;
              return (
                <Card
                  key={index}
                  onClick={() => handleDomainClick(industry)}
                  className="group cursor-pointer border-none bg-white/5 backdrop-blur-sm transition-all hover:scale-105 hover:bg-white/10 hover:shadow-xl"
                >
                  <CardContent className="flex flex-col items-center p-6 text-center">
                    <div
                      className="mb-4 rounded-full p-4 transition-all group-hover:scale-110"
                      style={{ backgroundColor: accentColor }}
                    >
                      <IconComponent className="h-8 w-8" style={{ color: bgColor }} />
                    </div>
                    <h3 className="text-sm font-semibold text-white">{industry.name}</h3>
                    <p className="mt-2 text-xs text-white/70">Click for insights</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      <DomainDetailModal
        domain={selectedDomain}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default Industries;
